module.exports = __webpack_public_path__ + "img/ammenities_map.jpg";